// extracted by mini-css-extract-plugin
module.exports = {"btnSend":"component_btnSend__2-NWE","spin":"component_spin__2WVpg","appear":"component_appear__3qaCm"};